module.exports = __webpack_public_path__ + "img/move.2930fc8a.webp";